import {
  ALLOCATION_PANEL_AS_OF_DATE_DATE_FORMAT,
  ALLOCATION_PANEL_AS_OF_DATE_DISPLAY_FORMAT,
  FormattedDateString,
} from 'venn-utils';
import moment from 'moment/moment';
import { Match } from 'effect';

export const formatDateForCalendarDropdown = (date: FormattedDateString): string => {
  return moment.utc(date, ALLOCATION_PANEL_AS_OF_DATE_DATE_FORMAT).format(ALLOCATION_PANEL_AS_OF_DATE_DISPLAY_FORMAT);
};

export const UNSAFE_formatStringDateForCalendarDropdown = (date: string): string => {
  // this function is unsafe because it does not check if the date is in a valid format ('MM/DD/YYYY')
  // FormattedDateString will crash if the date is not in a valid format
  return Match.value(date).pipe(
    Match.when('Current', () => 'Current'),
    Match.when('LastUploaded', () => 'Last Uploaded'),
    Match.orElse((date) => formatDateForCalendarDropdown(FormattedDateString(date))),
  );
};
